exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  text-align: center;\n  padding-top: 50px; }\n\napp-d3graph {\n  display: block;\n  position: absolute;\n  z-index: 2;\n  width: 99%;\n  background: #efece8;\n  margin: -60px 5px 0px 5px;\n  padding-top: 60px;\n  border-radius: 5px;\n  box-shadow: -1px 3px 5px 0px rgba(0, 0, 0, 0.5); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/visulisation/visulisation.component.scss
// module id = ../../../../../src/app/visulisation/visulisation.component.scss
// module chunks = main